<template lang="pug">
erp-view(id="ControlRoles" ref="ControlRoles" title="Control de Roles")

  template(slot="header-action")
    dx-button(text="Agregar Rol" icon="fa fa-plus" type="success" @click="nuevoRol")
    dx-button(text="Editar" icon="fa fa-edit" type="default" @click="editarRol")
    dx-button(text="Clonar" icon="fa fa-clone" type="default" @click="clonarRol")
    dx-button(text="Eliminar" icon="fa fa-trash" type="danger" @click="eliminarRol")

  template(slot="content")
    dx-data-grid(:data-source="roles" :show-borders="true" key-expr="nombre")
      dx-column(data-field="nombre" caption="Rol" width="200")
      dx-column(data-field="descripcion" caption="Descripción" width="400")
      dx-column(data-field="estado" caption="Estado" width="100")
</template>

<script>
import { DxDataGrid, DxColumn, DxButton } from "devextreme-vue/data-grid";

export default {
  name: "ControlRoles",
  components: { DxDataGrid, DxColumn, DxButton },
  data() {
    return {
      roles: [
        { nombre: "Admin", descripcion: "Acceso total al sistema", estado: "Activo" },
        { nombre: "Ventas", descripcion: "Gestión de pedidos y clientes", estado: "Activo" },
        { nombre: "Soporte", descripcion: "Atención a reclamos y soporte", estado: "Inactivo" },
      ],
    };
  },
  methods: {
    nuevoRol() { this.$msg.info("Abrir popup: Nuevo Rol"); },
    editarRol() { this.$msg.info("Editar rol seleccionado"); },
    clonarRol() { this.$msg.info("Clonar rol seleccionado"); },
    eliminarRol() { this.$msg.confirm("¿Deseas eliminar este rol?"); },
  },
};
</script>
